import React, { useEffect } from "react";

const TodoList = () => {
  function todoListForm() {
    const form = document.querySelector("form");
    const item = document.querySelector("#item");
    const list = document.querySelector("ul");

    // Pour stocker les infos dans le Local Storage
    function storeList() {
      window.localStorage.todoList = list.innerHTML;
    }
    // Pour rappeler les infos stockées dans le Local Storage
    function getTodos() {
      // const list = document.querySelector("ul");
      if (window.localStorage.todoList) {
        list.innerHTML = window.localStorage.todoList;
      } else {
        list.innerHTML = `<li>Cliquez sur un item pour le supprimer</li>`;
      }
    }
    window.addEventListener("load", getTodos);

    // Pour ajouter des éléments
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      // Pour récupérer le contenu d'une balise : textcontent
      // Pour les inputs : value
      // Le signe "=" donne la valeur de droite à gauche et écrase les données précédentes
      // Pour ne pas écraser mais concaténer : "+="
      list.innerHTML += `<li>${item.value}</li>`;
      // Pour revenir à zéro après une précédente saisie
      item.value = "";
      storeList();
    });
    // Pour déterminer sur quelle ligne j'ai cliqué pour pouvoir la supprimer : e.target
    list.addEventListener("click", (e) => {
      // Si n'a pas la class checked, tu lui rajoutes, sinon, tu la supprimes
      if (e.target.classList.contains("checked")) {
        e.target.remove();
      } else {
        e.target.classList.add("checked");
      }
      storeList();
    });
  }
  useEffect(todoListForm);

  return (
    <div>
      <div className="page-container-todolist">
        <div className="todolist-container">
          <h2>To do list</h2>
          <form action="">
            <input
              type="text"
              id="item"
              placeholder="À faire"
              autoComplete="off"
              minLength="2"
              className="hover"
            />
          </form>
          <ul id="list" className="hover"></ul>
        </div>
      </div>
    </div>
  );
};

export default TodoList;
